import { Section } from '../components/Section/Section'
import OnlineFollowersHeatmap from '../components/OnlineFollowersHeatmap/OnlineFollowersHeatmap'
import { OnlineFollowersMetric } from 'hooks/queries/audienceMetrics/types'
import { useAudienceMetrics } from 'hooks/queries/audienceMetrics/useAudienceMetrics'
import useURLParams from 'hooks/useURLParams'

export const OnlineFollowersActivity = () => {
  const [searchParams] = useURLParams()

  const { data, isFetching } = useAudienceMetrics(parseInt(searchParams.get('external_integration_id') as string))

  const onlineFollowersMetric = data?.find((metric) => metric.metric_type === 'online_followers') as
    | OnlineFollowersMetric
    | undefined

  return (
    <Section title="Followers online activity">
      <OnlineFollowersHeatmap data={onlineFollowersMetric?.data} isFetching={isFetching} />
    </Section>
  )
}
